import React from 'react';
import { componentFromInput } from '../util';
var Label = function Label(_ref) {
  var name = _ref.name,
    styles = _ref.styles,
    label = _ref.label,
    required = _ref.required;
  var LabelComponent = componentFromInput(label);
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: "control-label ".concat(styles.label)
  }, /*#__PURE__*/React.createElement(LabelComponent, null), required ? /*#__PURE__*/React.createElement("em", {
    className: "text-danger"
  }, "*") : null);
};
export default Label;